import React, { ReactNode } from 'react';

import { ClassName } from '../../../../../types';

interface IndexTableBodyProps {
  children: ReactNode;
  className?: ClassName;
}

function IndexTableBody({ children, className }: IndexTableBodyProps) {
  return (
    <tbody
      className={className || 'dark:divide-gray-800 divide-gray-200 divide-y'}
    >
      {children}
    </tbody>
  );
}

export default IndexTableBody;
